export const handlePrint = (contact, rows, printContactList) => {
  printContactList(contact, rows);
};
